/* MyoBuddy 2AG homepage interactions — scoped to .mb2ag */
(function () {
  "use strict";
  if (window.__mb2agHomeInit) return;
  window.__mb2agHomeInit = true;

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  ready(function () {
    /* mobile nav burger (header also has inline wiring; this is a fallback) */
    document.querySelectorAll("[data-mb2ag-nav]").forEach(function (nav) {
      if (nav.dataset.menuWired) return;
      var burger = nav.querySelector("[data-mb2ag-burger]");
      var menu = nav.querySelector(".mobile-menu");
      if (!burger || !menu) return;
      nav.dataset.menuWired = "1";
      function setOpen(open) {
        nav.classList.toggle("menu-open", open);
        burger.setAttribute("aria-expanded", open ? "true" : "false");
      }
      burger.addEventListener("click", function (e) {
        e.preventDefault();
        setOpen(!nav.classList.contains("menu-open"));
      });
      menu.querySelectorAll("a").forEach(function (link) {
        link.addEventListener("click", function () {
          setOpen(false);
        });
      });
    });

    /* marquee: duplicate track for seamless loop */
    document.querySelectorAll(".mb2ag .marquee-track").forEach(function (track) {
      if (track.dataset.duplicated) return;
      track.innerHTML += track.innerHTML;
      track.dataset.duplicated = "1";
    });

    /* complete your kit — one product at a time; arrows and swipes slide the rail */
    document.querySelectorAll(".mb2ag [data-mb2ag-kit]").forEach(function (kit) {
      /* this file is included once per section — wire each slider only once */
      if (kit.dataset.wired) return;
      kit.dataset.wired = "1";
      var rail = kit.querySelector("[data-kit-rail]");
      var prev = kit.querySelector("[data-kit-prev]");
      var next = kit.querySelector("[data-kit-next]");
      if (!rail || !prev || !next) return;
      var items = Array.prototype.slice.call(rail.children);
      var index = 0;
      function go(i) {
        index = Math.max(0, Math.min(items.length - 1, i));
        rail.style.transform = "translateX(" + index * -100 + "%)";
        prev.disabled = index === 0;
        next.disabled = index === items.length - 1;
        items.forEach(function (item, n) {
          /* keep off-screen products out of the tab order */
          if (n === index) item.removeAttribute("inert");
          else item.setAttribute("inert", "");
        });
      }
      prev.addEventListener("click", function () { go(index - 1); });
      next.addEventListener("click", function () { go(index + 1); });
      var startX = null;
      var startY = null;
      rail.addEventListener("touchstart", function (e) {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
      }, { passive: true });
      rail.addEventListener("touchend", function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        var dy = e.changedTouches[0].clientY - startY;
        startX = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(index + (dx < 0 ? 1 : -1));
      }, { passive: true });
      go(0);
    });

    /* accordions — one open per group */
    document.querySelectorAll(".mb2ag .acc").forEach(function (group) {
      group.querySelectorAll(".acc-item").forEach(function (item) {
        var head = item.querySelector(".acc-head");
        var body = item.querySelector(".acc-body");
        if (!head || !body) return;
        head.addEventListener("click", function () {
          var isOpen = item.classList.contains("open");
          group.querySelectorAll(".acc-item.open").forEach(function (o) {
            o.classList.remove("open");
            var b = o.querySelector(".acc-body");
            if (b) b.style.maxHeight = null;
          });
          if (!isOpen) {
            item.classList.add("open");
            body.style.maxHeight = body.scrollHeight + "px";
          }
        });
      });
    });

    /* FAQ — show 5, then view more / view less */
    document.querySelectorAll(".mb2ag [data-faq-list]").forEach(function (list) {
      var acc = list.querySelector(".faq-acc");
      var btn = list.querySelector("[data-faq-toggle]");
      if (!acc || !btn) return;
      var moreLabel = btn.getAttribute("data-more") || "View more";
      var lessLabel = btn.getAttribute("data-less") || "View less";
      btn.addEventListener("click", function () {
        var expanded = acc.classList.toggle("is-expanded");
        btn.setAttribute("aria-expanded", expanded ? "true" : "false");
        btn.textContent = expanded ? lessLabel : moreLabel;
        if (!expanded) {
          acc.querySelectorAll(".faq-item-extra.open").forEach(function (item) {
            item.classList.remove("open");
            var body = item.querySelector(".acc-body");
            if (body) body.style.maxHeight = null;
          });
          var grid = list.closest(".faq-grid");
          if (grid) grid.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      });
    });

    /* community + product gallery media cards — play uploaded video on badge click */
    function pauseMediaCards(except) {
      document.querySelectorAll(".mb2ag [data-mb2ag-media-card].is-playing").forEach(function (other) {
        if (except && other === except) return;
        var v = other.querySelector("video");
        if (v) v.pause();
        other.classList.remove("is-playing");
      });
    }
    document.querySelectorAll(".mb2ag [data-mb2ag-media-card]").forEach(function (card) {
      var video = card.querySelector("video");
      var badge = card.querySelector(".play-badge");
      if (!video || !badge) return;
      function play() {
        pauseMediaCards(card);
        card.classList.add("is-playing");
        var p = video.play();
        if (p && typeof p.catch === "function") p.catch(function () {});
      }
      function pause() {
        video.pause();
        card.classList.remove("is-playing");
      }
      badge.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (video.paused) play();
        else pause();
      });
      card.addEventListener("click", function () {
        if (!card.classList.contains("is-playing")) return;
        pause();
      });
    });

    /* Horizontal carousels — click-and-drag with mouse */
    function enableDragScroll(scroller) {
      if (!scroller || scroller.dataset.dragScroll) return;
      scroller.dataset.dragScroll = "1";
      var pointerId = null;
      var startX = 0;
      var startScroll = 0;
      var dragged = false;

      function onMove(e) {
        if (pointerId === null) return;
        var dx = e.pageX - startX;
        if (Math.abs(dx) > 6) {
          if (!dragged) {
            dragged = true;
            scroller.classList.add("is-dragging");
          }
          scroller.scrollLeft = startScroll - dx;
        }
      }

      function onUp() {
        if (pointerId === null) return;
        pointerId = null;
        scroller.classList.remove("is-dragging");
        window.removeEventListener("mousemove", onMove);
        window.removeEventListener("mouseup", onUp);
      }

      scroller.addEventListener("mousedown", function (e) {
        if (e.button !== 0) return;
        pointerId = 1;
        dragged = false;
        startX = e.pageX;
        startScroll = scroller.scrollLeft;
        window.addEventListener("mousemove", onMove);
        window.addEventListener("mouseup", onUp);
      });

      scroller.addEventListener(
        "click",
        function (e) {
          if (!dragged) return;
          e.preventDefault();
          e.stopPropagation();
          dragged = false;
        },
        true
      );

      scroller.addEventListener("dragstart", function (e) {
        e.preventDefault();
      });
    }

    document.querySelectorAll(
      ".mb2ag .real-relief__track, .mb2ag .expert-trust__track, .mb2ag .video-guides__track"
    ).forEach(enableDragScroll);

    /* Video banner — play/pause + mute, no native player chrome */
    (function initVideoBanners() {
      var banners = document.querySelectorAll("[data-mb2ag-video-banner]");
      if (!banners.length) return;
      var mql = window.matchMedia("(max-width: 900px)");
      var vimeoSdkLoading = null;

      function loadVimeoSdk(cb) {
        if (window.Vimeo && window.Vimeo.Player) {
          cb();
          return;
        }
        if (vimeoSdkLoading) {
          vimeoSdkLoading.then(cb);
          return;
        }
        vimeoSdkLoading = new Promise(function (resolve) {
          var s = document.createElement("script");
          s.src = "https://player.vimeo.com/api/player.js";
          s.onload = resolve;
          s.onerror = resolve;
          document.head.appendChild(s);
        });
        vimeoSdkLoading.then(cb);
      }

      function vimeoPlayer(iframe, cb) {
        if (!iframe) return;
        if (iframe.__mb2agPlayer) {
          cb(iframe.__mb2agPlayer);
          return;
        }
        loadVimeoSdk(function () {
          if (!window.Vimeo || !window.Vimeo.Player) return;
          iframe.__mb2agPlayer = new window.Vimeo.Player(iframe);
          cb(iframe.__mb2agPlayer);
        });
      }

      function fitMedia(el, w, h, mode, clip) {
        if (!el || !w || !h) return;
        el.__mb2agW = w;
        el.__mb2agH = h;
        if (mode === "mobile") {
          el.style.position = "";
          el.style.left = "";
          el.style.top = "";
          el.style.transform = "";
          el.style.aspectRatio = w + " / " + h;
          el.style.width = "100%";
          el.style.maxWidth = "100%";
          el.style.height = "auto";
          el.style.maxHeight = "none";
          return;
        }
        if (el.tagName === "VIDEO") {
          el.style.position = "absolute";
          el.style.left = "0";
          el.style.top = "0";
          el.style.transform = "";
          el.style.aspectRatio = "";
          el.style.width = "100%";
          el.style.height = "100%";
          el.style.maxWidth = "none";
          el.style.maxHeight = "none";
          el.style.objectFit = "cover";
          return;
        }
        var boxW = (clip && clip.clientWidth) || window.innerWidth;
        var boxH = (clip && clip.clientHeight) || Math.max(1, window.innerHeight - 96);
        var scale = Math.max(boxW / w, boxH / h);
        el.style.position = "absolute";
        el.style.left = "50%";
        el.style.top = "50%";
        el.style.transform = "translate(-50%, -50%)";
        el.style.aspectRatio = "auto";
        el.style.width = Math.ceil(w * scale) + "px";
        el.style.height = Math.ceil(h * scale) + "px";
        el.style.maxWidth = "none";
        el.style.maxHeight = "none";
      }

      function fitClip(clip) {
        if (!clip) return;
        var mode = clip.getAttribute("data-banner-video") === "mobile" ? "mobile" : "desktop";
        var video = clip.querySelector("video");
        var iframe = clip.querySelector("iframe");
        if (video) {
          function applyVideoFit() {
            if (video.videoWidth && video.videoHeight) {
              fitMedia(video, video.videoWidth, video.videoHeight, mode, clip);
            }
          }
          applyVideoFit();
          if (!video.__mb2agFitBound) {
            video.__mb2agFitBound = true;
            video.addEventListener("loadedmetadata", applyVideoFit);
          }
        }
        if (iframe) {
          if (iframe.__mb2agW && iframe.__mb2agH) {
            fitMedia(iframe, iframe.__mb2agW, iframe.__mb2agH, mode, clip);
            return;
          }
          vimeoPlayer(iframe, function (player) {
            var wP = player.getVideoWidth ? player.getVideoWidth() : Promise.resolve(null);
            var hP = player.getVideoHeight ? player.getVideoHeight() : Promise.resolve(null);
            Promise.all([wP, hP])
              .then(function (wh) {
                if (wh[0] && wh[1]) fitMedia(iframe, wh[0], wh[1], mode, clip);
              })
              .catch(function () {});
          });
        }
      }

      function fitAll() {
        banners.forEach(function (banner) {
          banner.querySelectorAll(".video-banner__clip").forEach(fitClip);
        });
      }

      function activeClip(banner) {
        return banner.querySelector(
          mql.matches ? "[data-banner-video='mobile']" : "[data-banner-video='desktop']"
        );
      }

      function applyPlay(clip, shouldPlay) {
        if (!clip) return;
        var video = clip.querySelector("video");
        var iframe = clip.querySelector("iframe");
        if (video) {
          video.controls = false;
          if (shouldPlay) {
            var p = video.play();
            if (p && typeof p.catch === "function") p.catch(function () {});
          } else {
            video.pause();
          }
        }
        if (iframe) {
          vimeoPlayer(iframe, function (player) {
            if (shouldPlay) player.play().catch(function () {});
            else player.pause().catch(function () {});
          });
        }
      }

      function applyMute(clip, muted) {
        if (!clip) return;
        var video = clip.querySelector("video");
        var iframe = clip.querySelector("iframe");
        if (video) video.muted = muted;
        if (iframe) {
          vimeoPlayer(iframe, function (player) {
            player.setMuted(muted).catch(function () {});
            if (!muted) player.setVolume(1).catch(function () {});
          });
        }
      }

      function syncUi(banner) {
        var playBtn = banner.querySelector("[data-banner-play]");
        var muteBtn = banner.querySelector("[data-banner-mute]");
        var paused = !!banner.__mb2agUserPaused;
        var muted = banner.__mb2agUserMuted !== false;
        if (playBtn) {
          playBtn.classList.toggle("is-paused", paused);
          playBtn.setAttribute("aria-label", paused ? "Play" : "Pause");
        }
        if (muteBtn) {
          muteBtn.classList.toggle("is-muted", muted);
          muteBtn.setAttribute("aria-label", muted ? "Unmute" : "Mute");
        }
      }

      function sync(banner) {
        var inView = banner.__mb2agInView !== false;
        var shouldPlay = inView && !banner.__mb2agUserPaused;
        var muted = banner.__mb2agUserMuted !== false;
        var desktop = banner.querySelector("[data-banner-video='desktop']");
        var mobile = banner.querySelector("[data-banner-video='mobile']");
        var useMobile = mql.matches;
        applyMute(useMobile ? mobile : desktop, muted);
        applyPlay(desktop, shouldPlay && !useMobile);
        applyPlay(mobile, shouldPlay && useMobile);
        syncUi(banner);
      }

      function syncAll() {
        banners.forEach(sync);
      }

      banners.forEach(function (banner) {
        banner.__mb2agUserPaused = false;
        banner.__mb2agUserMuted = true;

        var playBtn = banner.querySelector("[data-banner-play]");
        var muteBtn = banner.querySelector("[data-banner-mute]");
        var hit = banner.querySelector("[data-banner-toggle-play]");

        function togglePlay(e) {
          if (e) e.preventDefault();
          banner.__mb2agUserPaused = !banner.__mb2agUserPaused;
          sync(banner);
        }
        function toggleMute(e) {
          if (e) {
            e.preventDefault();
            e.stopPropagation();
          }
          banner.__mb2agUserMuted = !banner.__mb2agUserMuted;
          applyMute(activeClip(banner), banner.__mb2agUserMuted);
          syncUi(banner);
        }

        if (hit) hit.addEventListener("click", togglePlay);
        if (playBtn) playBtn.addEventListener("click", togglePlay);
        if (muteBtn) muteBtn.addEventListener("click", toggleMute);
      });

      fitAll();
      window.addEventListener("resize", fitAll);

      function onViewportChange() {
        fitAll();
        syncAll();
      }
      if (typeof mql.addEventListener === "function") mql.addEventListener("change", onViewportChange);
      else if (typeof mql.addListener === "function") mql.addListener(onViewportChange);

      if ("IntersectionObserver" in window) {
        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              entry.target.__mb2agInView = entry.isIntersecting;
              sync(entry.target);
            });
          },
          { threshold: 0.2 }
        );
        banners.forEach(function (banner) {
          io.observe(banner);
        });
      } else {
        banners.forEach(function (banner) {
          banner.__mb2agInView = true;
        });
        syncAll();
      }
    })();

    /* UGC real-relief clips — play muted while visible; click opens popup */
    var ugcPopupOpen = false;
    if ("IntersectionObserver" in window) {
      var ugcIo = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var video = entry.target;
            if (ugcPopupOpen) {
              video.pause();
              return;
            }
            if (entry.isIntersecting) {
              var p = video.play();
              if (p && typeof p.catch === "function") p.catch(function () {});
            } else {
              video.pause();
            }
          });
        },
        { threshold: 0.45 }
      );
      document.querySelectorAll(".mb2ag .rr-card video").forEach(function (video) {
        ugcIo.observe(video);
      });
    }

    /* Video popup — YouTube embeds + Real Relief hosted clips */
    (function initMediaModal() {
      var dialog = document.querySelector("[data-mb2ag-yt-dialog]");
      if (!dialog) {
        dialog = document.createElement("div");
        dialog.className = "yt-modal";
        dialog.setAttribute("data-mb2ag-yt-dialog", "");
        dialog.setAttribute("hidden", "");
        dialog.setAttribute("role", "dialog");
        dialog.setAttribute("aria-modal", "true");
        dialog.setAttribute("aria-label", "Video player");
        dialog.innerHTML =
          '<div class="yt-modal__backdrop" data-mb2ag-yt-close></div>' +
          '<div class="yt-modal__panel">' +
          '<button type="button" class="yt-modal__close" data-mb2ag-yt-close aria-label="Close video">&times;</button>' +
          '<div class="yt-modal__frame">' +
          '<iframe data-mb2ag-yt-iframe src="" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>' +
          '<video data-mb2ag-yt-video controls playsinline preload="auto"></video>' +
          "</div></div>";
        document.body.appendChild(dialog);
      }
      if (dialog.parentNode !== document.body) document.body.appendChild(dialog);

      var iframe = dialog.querySelector("[data-mb2ag-yt-iframe]");
      var popupVideo = dialog.querySelector("[data-mb2ag-yt-video]");
      var panel = dialog.querySelector(".yt-modal__panel");
      if (!popupVideo && dialog.querySelector(".yt-modal__frame")) {
        popupVideo = document.createElement("video");
        popupVideo.setAttribute("data-mb2ag-yt-video", "");
        popupVideo.setAttribute("controls", "");
        popupVideo.setAttribute("playsinline", "");
        popupVideo.setAttribute("preload", "auto");
        popupVideo.hidden = true;
        dialog.querySelector(".yt-modal__frame").appendChild(popupVideo);
      }
      var lastFocus = null;

      function embedSrc(id) {
        return (
          "https://www.youtube.com/embed/" +
          encodeURIComponent(id) +
          "?autoplay=1&rel=0&modestbranding=1&playsinline=1"
        );
      }

      function pauseInlineUgc() {
        document.querySelectorAll(".mb2ag .rr-card video").forEach(function (video) {
          video.pause();
        });
        pauseMediaCards();
      }

      function closeMedia() {
        ugcPopupOpen = false;
        dialog.setAttribute("hidden", "");
        document.body.style.overflow = "";
        if (iframe) {
          iframe.src = "";
          iframe.hidden = false;
        }
        if (popupVideo) {
          popupVideo.pause();
          popupVideo.removeAttribute("src");
          popupVideo.load();
          popupVideo.hidden = true;
        }
        if (panel) panel.classList.remove("is-portrait");
        if (lastFocus && typeof lastFocus.focus === "function") lastFocus.focus();
      }

      function openDialog() {
        lastFocus = document.activeElement;
        dialog.removeAttribute("hidden");
        document.body.style.overflow = "hidden";
        var closeBtn = dialog.querySelector("[data-mb2ag-yt-close]");
        if (closeBtn) closeBtn.focus();
      }

      function openYt(id) {
        if (!id || !iframe) return;
        ugcPopupOpen = true;
        pauseInlineUgc();
        if (panel) panel.classList.remove("is-portrait");
        if (popupVideo) {
          popupVideo.pause();
          popupVideo.removeAttribute("src");
          popupVideo.hidden = true;
        }
        iframe.hidden = false;
        iframe.src = embedSrc(id);
        openDialog();
      }

      function openUgc(card) {
        var source = card.querySelector("video");
        if (!source || !popupVideo) return;
        var src = source.currentSrc || source.src;
        if (!src) {
          var sourceEl = source.querySelector("source");
          if (sourceEl) src = sourceEl.getAttribute("src");
        }
        if (!src) return;
        ugcPopupOpen = true;
        pauseInlineUgc();
        if (panel) panel.classList.add("is-portrait");
        if (iframe) {
          iframe.src = "";
          iframe.hidden = true;
        }
        popupVideo.hidden = false;
        popupVideo.src = src;
        popupVideo.muted = false;
        popupVideo.currentTime = 0;
        openDialog();
        var playPromise = popupVideo.play();
        if (playPromise && typeof playPromise.catch === "function") {
          playPromise.catch(function () {});
        }
      }

      document.querySelectorAll("[data-mb2ag-yt-open]").forEach(function (trigger) {
        trigger.addEventListener("click", function (e) {
          e.preventDefault();
          openYt(trigger.getAttribute("data-mb2ag-yt-open"));
        });
      });

      document.addEventListener("click", function (e) {
        var card = e.target.closest("[data-mb2ag-ugc-open]");
        if (!card || !document.contains(card)) return;
        e.preventDefault();
        openUgc(card);
      });
      document.addEventListener("keydown", function (e) {
        if (e.key !== "Enter" && e.key !== " ") return;
        var card = e.target.closest("[data-mb2ag-ugc-open]");
        if (!card) return;
        e.preventDefault();
        openUgc(card);
      });

      dialog.querySelectorAll("[data-mb2ag-yt-close]").forEach(function (el) {
        el.addEventListener("click", closeMedia);
      });

      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape" && !dialog.hasAttribute("hidden")) closeMedia();
      });
    })();

    /* variant selectors — scoped to product root; prefers JSON payload when present */
    function decodeEntitiesDeep(str) {
      var cur = String(str == null ? "" : str);
      for (var i = 0; i < 5; i++) {
        var el = document.createElement("textarea");
        el.innerHTML = cur;
        var next = el.value;
        if (next === cur) break;
        cur = next;
      }
      return cur;
    }

    function fixEncodedTextNodes(root) {
      if (!root) return;
      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
      var nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach(function (node) {
        var val = node.nodeValue || "";
        if (/&(?:amp|quot|lt|gt|nbsp|#\d+|#x[0-9a-f]+);/i.test(val)) {
          node.nodeValue = decodeEntitiesDeep(val);
        }
      });
    }

    function parseStatParts(rawLine) {
      var text = decodeEntitiesDeep(String(rawLine || "").replace(/\s+/g, " ").trim());
      if (!text) return null;
      var detailStarts =
        /^(combined|from|covers|for|with|across|to|and|of|built|perfect|everyday|enhanced|our|that|which|wide|massage)$/i;
      /* Support 6" / 6″ attached to the number */
      var m = text.match(/^(\d+)(["″”']?)\s+(.+)$/);
      if (!m) return { num: "", label: text, detail: "", text: text };
      var num = m[1] + (m[2] || "");
      var parts = m[3].split(/\s+/);
      var label;
      var detail;
      if (parts.length >= 2 && detailStarts.test(parts[1])) {
        label = parts[0];
        detail = parts.slice(1).join(" ");
      } else if (parts.length >= 3 && detailStarts.test(parts[2])) {
        label = parts[0] + " " + parts[1];
        detail = parts.slice(2).join(" ");
      } else if (parts.length >= 2) {
        label = parts[0];
        detail = parts.slice(1).join(" ");
      } else {
        label = parts[0] || "";
        detail = "";
      }
      return { num: num, label: label, detail: detail, text: text };
    }

    function appendStatRow(box, rawLine) {
      var parts = parseStatParts(rawLine);
      if (!parts) return;
      var row = document.createElement("div");
      row.className = "stat-row";
      var b = document.createElement("b");
      if (parts.num) {
        var numEl = document.createElement("span");
        numEl.className = "num";
        numEl.textContent = parts.num;
        b.appendChild(numEl);
        b.appendChild(document.createTextNode(" " + parts.label));
      } else {
        b.textContent = parts.label || parts.text;
      }
      row.appendChild(b);
      if (parts.detail) {
        row.appendChild(document.createTextNode(" " + parts.detail));
      }
      box.appendChild(row);
    }

    function enhanceStatBox(box) {
      if (!box) return;
      var lines = [];
      var rich = box.querySelector(".stat-rich");
      if (rich) {
        var nodes = rich.querySelectorAll("p, li");
        if (nodes.length) {
          Array.prototype.forEach.call(nodes, function (node) {
            var t = decodeEntitiesDeep((node.textContent || "").trim());
            if (t) lines.push(t);
          });
        } else {
          decodeEntitiesDeep((rich.textContent || "").trim())
            .split(/\n+/)
            .forEach(function (t) {
              t = t.trim();
              if (t) lines.push(t);
            });
        }
      } else {
        box.querySelectorAll(".stat-row").forEach(function (row) {
          var t = decodeEntitiesDeep((row.textContent || "").trim());
          if (t) lines.push(t);
        });
      }
      if (!lines.length) return;
      box.innerHTML = "";
      lines.forEach(function (line) {
        appendStatRow(box, line);
      });
    }

    function ingredientsTextFromHtml(html) {
      if (!html) return "";
      var wrap = document.createElement("div");
      wrap.innerHTML = html;
      fixEncodedTextNodes(wrap);
      var parts = [];
      var blocks = wrap.querySelectorAll("p, li");
      if (blocks.length) {
        Array.prototype.forEach.call(blocks, function (el) {
          var t = decodeEntitiesDeep((el.textContent || "").trim());
          if (t) parts.push(t);
        });
        return parts.join("\n");
      }
      return decodeEntitiesDeep(wrap.textContent || "")
        .replace(/\u00a0/g, " ")
        .split(/\n+/)
        .map(function (l) {
          return l.trim();
        })
        .filter(Boolean)
        .join("\n");
    }

    function renderStatRows(box, text) {
      if (!box) return;
      var lines = String(text || "")
        .replace(/\r/g, "")
        .split(/\n+/)
        .map(function (l) {
          return decodeEntitiesDeep(l.replace(/<br\s*\/?>/gi, "").trim());
        })
        .filter(Boolean);
      box.innerHTML = "";
      if (!lines.length) {
        box.style.display = "none";
        return;
      }
      box.style.display = "";
      lines.forEach(function (line) {
        appendStatRow(box, line);
      });
    }

    function applyVariantUI(root, data) {
      if (!root || !data) return;
      var title = root.querySelector("[data-mb2ag-title]");
      var price = root.querySelector("[data-mb2ag-price]");
      var compare = root.querySelector("[data-mb2ag-compare]");
      var save = root.querySelector("[data-mb2ag-save]");
      var desc = root.querySelector("[data-mb2ag-desc]");
      var stats = root.querySelector("[data-mb2ag-stats]");
      var badges = root.querySelector("[data-mb2ag-badges]");
      var included = root.querySelector("[data-mb2ag-included]");
      var variantInput = root.querySelector("[data-mb2ag-variant-id]");
      var atc = root.querySelector("[data-mb2ag-atc]");

      if (title && data.title) title.textContent = decodeEntitiesDeep(data.title);
      var vendor = root.querySelector("[data-mb2ag-vendor]");
      if (vendor && data.vendor) vendor.textContent = decodeEntitiesDeep(data.vendor);
      if (price && data.price) price.textContent = data.price;
      if (compare) {
        compare.textContent = data.compare || "";
        compare.style.display = data.compare ? "" : "none";
      }
      if (save) {
        save.textContent = data.save || "";
        save.style.display = data.save ? "" : "none";
      }
      if (desc && data.description != null) {
        desc.innerHTML = data.description || "";
        desc.style.display = data.description ? "" : "none";
        fixEncodedTextNodes(desc);
      }
      if (badges) {
        var mode = data.badgeMode || "";
        var raw = data.badgesRaw != null ? String(data.badgesRaw) : "";
        var list = Array.isArray(data.badges) ? data.badges : [];
        if (!mode && data.badgesText) {
          list = String(data.badgesText)
            .split("|||")
            .map(function (s) {
              return decodeEntitiesDeep(s);
            })
            .filter(function (s) {
              return s !== "";
            });
          mode = "SPLIT";
        }
        badges.innerHTML = "";
        badges.classList.toggle("badges--metafield", mode === "RAW");
        if (mode === "RAW") {
          var rawSpan = document.createElement("span");
          rawSpan.className = "badge-line badge-line--raw";
          rawSpan.textContent = decodeEntitiesDeep(raw);
          badges.appendChild(rawSpan);
          badges.style.display = raw ? "" : "none";
        } else {
          list.forEach(function (label) {
            var text = decodeEntitiesDeep(label);
            if (text === "") return;
            var span = document.createElement("span");
            span.className = "badge-line";
            span.textContent = text;
            badges.appendChild(span);
          });
          badges.style.display = list.length ? "" : "none";
        }
      }
      if (stats) {
        var statsHtml =
          data.ingredientsHtml != null ? String(data.ingredientsHtml).trim() : "";
        if (statsHtml) {
          stats.innerHTML = statsHtml;
          stats.style.display = "";
          fixEncodedTextNodes(stats);
          enhanceStatBox(stats);
        } else {
          var ing = data.ingredients || "";
          if ((!ing || !/\n/.test(String(ing))) && data.ingredientsSourceHtml) {
            ing = ingredientsTextFromHtml(data.ingredientsSourceHtml);
          } else if (ing && /<[^>]+>/.test(String(ing))) {
            ing = ingredientsTextFromHtml(ing);
          }
          renderStatRows(stats, decodeEntitiesDeep(ing));
        }
      }
      if (included && data.includedHtml != null) {
        var includedHtml = String(data.includedHtml).trim();
        if (includedHtml) {
          included.innerHTML = includedHtml;
          fixEncodedTextNodes(included);
          var accItem = included.closest(".acc-item");
          if (accItem && accItem.classList.contains("open")) {
            included.style.maxHeight = included.scrollHeight + "px";
          }
        }
      }
      var specs = root.querySelector("[data-mb2ag-specs]");
      if (specs && data.specsHtml) {
        specs.innerHTML = String(data.specsHtml);
        var specsItem = specs.closest(".acc-item");
        if (specsItem && specsItem.classList.contains("open")) {
          specs.style.maxHeight = specs.scrollHeight + "px";
        }
      }
      if (data.image || data.mediaId) {
        function setImgSrc(img, url, alt) {
          if (!img || !url) return;
          img.removeAttribute("srcset");
          img.removeAttribute("sizes");
          /* Force reload even if the browser cached a prior srcset candidate */
          img.src = "";
          img.src = url;
          if (alt) img.alt = decodeEntitiesDeep(alt);
        }

        var gallery = root.querySelector("[data-mb2ag-gallery]");
        var shown = false;
        if (gallery && data.mediaId && typeof gallery.__mb2agShow === "function") {
          shown = gallery.__mb2agShow(String(data.mediaId));
        }

        var variantThumb = gallery && gallery.querySelector("[data-mb2ag-variant-thumb]");
        if (variantThumb && data.mediaId) {
          variantThumb.setAttribute("data-mb2ag-thumb", String(data.mediaId));
          var thumbImg = variantThumb.querySelector("img");
          if (thumbImg && data.image) {
            thumbImg.removeAttribute("srcset");
            thumbImg.src = data.image;
          }
          if (data.imageAlt) {
            variantThumb.setAttribute("aria-label", decodeEntitiesDeep(data.imageAlt));
          }
          var isVideoThumb = data.mediaType === "video" || data.mediaType === "external_video";
          variantThumb.classList.toggle("g-thumb--video", !!isVideoThumb);
          var playBadge = variantThumb.querySelector(".g-thumb-play");
          if (playBadge) {
            playBadge.hidden = !isVideoThumb;
          } else if (isVideoThumb) {
            var playEl = document.createElement("span");
            playEl.className = "g-thumb-play";
            playEl.setAttribute("aria-hidden", "true");
            variantThumb.appendChild(playEl);
          }
        }

        if (!shown && data.image) {
          var featureImg =
            root.querySelector(".g-viewer img[data-mb2ag-feature-img]") ||
            root.querySelector(".g-viewer.is-active img") ||
            root.querySelector(".g-main img[data-mb2ag-feature-img]");
          if (featureImg && !featureImg.closest("[data-mb2ag-media-card]")) {
            setImgSrc(featureImg, data.image, data.imageAlt);
            var featureSlide = featureImg.closest("[data-mb2ag-slide]");
            if (
              featureSlide &&
              gallery &&
              typeof gallery.__mb2agShow === "function"
            ) {
              gallery.__mb2agShow(featureSlide.getAttribute("data-mb2ag-slide"));
            }
          }
        }

        /* Mobile feature slide — drop an in-slide video so variant stills can take over */
        var mobileFeature = root.querySelector("[data-mb2ag-mobile-feature-slide]");
        if (mobileFeature && mobileFeature.querySelector("video, iframe")) {
          mobileFeature.innerHTML = "";
          mobileFeature.classList.add("contain");
          mobileFeature.classList.remove("is-playing", "g-slide--video");
          mobileFeature.removeAttribute("data-mb2ag-media-card");
          var mobileImg = document.createElement("img");
          mobileImg.setAttribute("data-mb2ag-feature-img", "");
          mobileFeature.appendChild(mobileImg);
        }

        /* Mobile feature slide + any other marked feature images in this product root */
        root.querySelectorAll(".g-mobile [data-mb2ag-feature-img], .feature-img [data-mb2ag-feature-img]").forEach(function (img) {
          setImgSrc(img, data.image, data.imageAlt);
        });

        var carousel = root.querySelector("[data-mb2ag-carousel]");
        if (carousel) {
          carousel.scrollTo({ left: 0, behavior: "smooth" });
        }
      }
      if (variantInput && data.id) variantInput.value = data.id;
      if (atc) {
        var available = data.available !== false && data.available !== "false";
        atc.disabled = !available;
        atc.textContent = available
          ? atc.getAttribute("data-atc-label") || "Add to Cart"
          : "Sold out";
      }

      /* keep the sticky add-to-cart bar in sync */
      var stickySelect = root.querySelector("[data-mb2ag-sticky-variant]");
      if (stickySelect && data.id != null && String(stickySelect.value) !== String(data.id)) {
        stickySelect.value = String(data.id);
      }
      var stickyTitle = root.querySelector("[data-mb2ag-sticky-title]");
      var stickyPrice = root.querySelector("[data-mb2ag-sticky-price]");
      var stickyCompare = root.querySelector("[data-mb2ag-sticky-compare]");
      var stickyImg = root.querySelector("[data-mb2ag-sticky-img]");
      var stickyAtc = root.querySelector("[data-mb2ag-sticky-atc]");
      if (stickyTitle && data.title) stickyTitle.textContent = decodeEntitiesDeep(data.title);
      if (stickyPrice && data.price) stickyPrice.textContent = data.price;
      if (stickyCompare) {
        stickyCompare.textContent = data.compare || "";
        if (data.compare) stickyCompare.removeAttribute("hidden");
        else stickyCompare.setAttribute("hidden", "");
      }
      if (stickyImg && data.image) {
        stickyImg.src = data.image;
        if (data.imageAlt) stickyImg.alt = decodeEntitiesDeep(data.imageAlt);
      }
      if (stickyAtc) {
        var stickyAvailable = data.available !== false && data.available !== "false";
        stickyAtc.disabled = !stickyAvailable;
        stickyAtc.textContent = stickyAvailable
          ? stickyAtc.getAttribute("data-atc-label") || "Add to Cart"
          : "Sold out";
      }
    }

    function wireVariants(group) {
      if (!group || group.dataset.wired) return;
      group.dataset.wired = "1";
      var root =
        group.closest("[data-mb2ag-product-root]") ||
        group.closest(".buy-card") ||
        group.closest(".buy-box") ||
        group.closest(".mb2ag") ||
        document;

      var jsonEl = root.querySelector("[data-mb2ag-product-json]");
      var productData = null;
      if (jsonEl) {
        try {
          productData = JSON.parse(jsonEl.textContent);
        } catch (err) {
          productData = null;
        }
      }

      group.querySelectorAll(".variant").forEach(function (v) {
        v.addEventListener("click", function () {
          if (v.disabled) return;
          group.querySelectorAll(".variant").forEach(function (x) {
            x.classList.remove("on");
          });
          v.classList.add("on");

          var data = null;
          if (productData && productData.variants && v.dataset.variantId) {
            data = productData.variants.find(function (item) {
              return String(item.id) === String(v.dataset.variantId);
            });
          }
          if (!data) {
            data = {
              id: v.dataset.variantId,
              title: v.dataset.title,
              vendor: v.dataset.vendor,
              price: v.dataset.price,
              compare: v.dataset.compare,
              save: v.dataset.save,
              description: v.dataset.desc,
              ingredients: v.dataset.ingredients,
              image: v.dataset.image,
              imageAlt: v.dataset.imageAlt,
              mediaId: v.dataset.mediaId || null,
              available: v.dataset.available !== "false",
              badgesText: v.dataset.badges || "",
            };
          }
          applyVariantUI(root, data);
        });
      });

      /* sync UI to the initially selected variant (stats/desc/price) */
      if (productData && productData.variants) {
        var selectedBtn = group.querySelector(".variant.on") || group.querySelector(".variant:not([disabled])");
        if (selectedBtn && selectedBtn.dataset.variantId) {
          var selectedData = productData.variants.find(function (item) {
            return String(item.id) === String(selectedBtn.dataset.variantId);
          });
          if (selectedData) applyVariantUI(root, selectedData);
        }
      }
    }
    document.querySelectorAll(".mb2ag .variants").forEach(wireVariants);
    document.querySelectorAll("[data-mb2ag-stats]").forEach(function (box) {
      fixEncodedTextNodes(box);
      enhanceStatBox(box);
    });
    document.querySelectorAll("[data-mb2ag-desc]").forEach(fixEncodedTextNodes);

    /* quantity steppers */
    document.querySelectorAll(".mb2ag .qty").forEach(function (q) {
      if (q.dataset.wired) return;
      q.dataset.wired = "1";
      var out = q.querySelector("output");
      if (!out) return;
      q.querySelectorAll("button").forEach(function (b) {
        b.addEventListener("click", function () {
          var n = Math.max(
            1,
            Math.min(9, parseInt(out.textContent, 10) + parseInt(b.dataset.d, 10))
          );
          out.textContent = n;
          var qtyRoot = q.closest("[data-mb2ag-product-root]") || q.closest(".mb2ag");
          var qtyInput = qtyRoot && qtyRoot.querySelector("[data-mb2ag-qty]");
          if (qtyInput) qtyInput.value = n;
        });
      });
    });

    /* sticky add-to-cart bar — show once the main ATC scrolls out of view */
    document.querySelectorAll("[data-mb2ag-sticky-bar]").forEach(function (bar) {
      if (bar.dataset.wired) return;
      bar.dataset.wired = "1";
      var root = bar.closest("[data-mb2ag-product-root]") || bar.closest(".mb2ag");
      if (!root) return;
      var form = root.querySelector("form.mb2ag-atc-form");
      var mainAtc = root.querySelector("[data-mb2ag-atc]");
      var stickyBtn = bar.querySelector("[data-mb2ag-sticky-atc]");

      /* Hand visibility control over to CSS class; keep it off-screen initially */
      bar.removeAttribute("hidden");

      function setVisible(show) {
        bar.classList.toggle("is-visible", !!show);
        bar.setAttribute("aria-hidden", show ? "false" : "true");
      }

      /* Reveal only after the shopper scrolls past the main add-to-cart button */
      if (mainAtc && "IntersectionObserver" in window) {
        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              /* Show when the main button is above the viewport (scrolled past),
                 hide while it is visible or still below the fold. */
              var below = entry.boundingClientRect.top > 0;
              setVisible(!entry.isIntersecting && !below);
            });
          },
          { root: null, threshold: 0 }
        );
        io.observe(mainAtc);
      } else {
        setVisible(true);
      }

      /* Variant select in the sticky bar drives the main variant buttons so
         the whole PDP (buy box + gallery + sticky bar) stays in sync */
      var stickySelect = bar.querySelector("[data-mb2ag-sticky-variant]");
      if (stickySelect) {
        stickySelect.addEventListener("change", function () {
          var id = stickySelect.value;
          if (!id) return;
          var mainBtn = root.querySelector(
            '[data-mb2ag-pdp-variants] .variant[data-variant-id="' + id + '"]'
          );
          if (mainBtn && !mainBtn.disabled) {
            mainBtn.click();
            return;
          }
          /* Fallback: apply straight from the JSON payload */
          var jsonEl = root.querySelector("[data-mb2ag-product-json]");
          if (!jsonEl) return;
          try {
            var pd = JSON.parse(jsonEl.textContent);
            var d = pd && pd.variants && pd.variants.find(function (item) {
              return String(item.id) === String(id);
            });
            if (d) applyVariantUI(root, d);
          } catch (err) {}
        });
      }

      /* Sticky button reuses the main product form add-to-cart flow */
      if (stickyBtn && form) {
        stickyBtn.addEventListener("click", function () {
          if (stickyBtn.disabled) return;
          if (typeof form.requestSubmit === "function") {
            form.requestSubmit();
          } else {
            form.dispatchEvent(new Event("submit", { bubbles: true, cancelable: true }));
          }
        });
      }
    });

    /* add to cart + open theme cart drawer */
    function openMb2agCartDrawer(lineItem) {
      updateMb2agCartCount();
      if (typeof Shopify !== "undefined" && typeof Shopify.onItemAdded === "function") {
        Shopify.onItemAdded(lineItem, true);
        return;
      }
      if (
        window.MinimogTheme &&
        MinimogTheme.Cart &&
        typeof MinimogTheme.Cart.openCartDrawer === "function"
      ) {
        Promise.resolve(MinimogTheme.Cart.refreshCart && MinimogTheme.Cart.refreshCart())
          .then(function () {
            return MinimogTheme.Cart.renderNewCart && MinimogTheme.Cart.renderNewCart();
          })
          .then(function () {
            MinimogTheme.Cart.openCartDrawer();
          })
          .catch(function () {
            MinimogTheme.Cart.openCartDrawer();
          });
        return;
      }
      showToast((lineItem && lineItem.title) || "Added to cart");
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:refresh", { bubbles: true })
      );
    }

    function mb2agAddToCart(fd, btn) {
      if (btn) btn.disabled = true;
      var root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : "/";
      return fetch(root + "cart/add.js", {
        method: "POST",
        body: fd,
        headers: { Accept: "application/json" },
      })
        .then(function (r) {
          return r.json().then(function (data) {
            if (!r.ok) throw data;
            return data;
          });
        })
        .then(function (data) {
          openMb2agCartDrawer(data);
          return data;
        })
        .catch(function (err) {
          var msg =
            (err && (err.description || err.message)) || "Could not add to cart";
          showToast(msg);
        })
        .finally(function () {
          if (btn) btn.disabled = false;
        });
    }

    /* product / related ATC forms — event delegation so related cards always work */
    document.addEventListener(
      "submit",
      function (e) {
        var form = e.target.closest && e.target.closest("form.mb2ag-atc-form");
        if (!form || !form.closest(".mb2ag")) return;
        e.preventDefault();
        e.stopPropagation();
        var submitBtn = form.querySelector('[type="submit"]');
        var fd = new FormData(form);
        var qtyOut = form.querySelector(".qty output");
        if (qtyOut) fd.set("quantity", qtyOut.textContent);
        mb2agAddToCart(fd, submitBtn);
      },
      true
    );

    /* related / mock ATC with variant id */
    document.addEventListener("click", function (e) {
      var btn = e.target.closest && e.target.closest("[data-mb2ag-related-atc], .mb2ag .related .atc[data-variant-id]");
      if (!btn || btn.type === "submit") return;
      e.preventDefault();
      var variantId = btn.getAttribute("data-variant-id");
      if (!variantId) {
        showToast((btn.getAttribute("data-name-str") || "Item") + " — link a product in the theme editor");
        return;
      }
      var fd = new FormData();
      fd.set("id", variantId);
      fd.set("quantity", "1");
      mb2agAddToCart(fd, btn);
    });

    function updateMb2agCartCount() {
      fetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : "/") + "cart.js", {
        headers: { Accept: "application/json" },
      })
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          document.querySelectorAll("[data-mb2ag-cart-count]").forEach(function (el) {
            el.textContent = cart.item_count;
          });
        })
        .catch(function () {});
    }

    /* mock ATC buttons (no form, no variant) — homepage demos only */
    document.querySelectorAll(".mb2ag .atc:not([type='submit']):not([data-mb2ag-related-atc]):not([data-variant-id])").forEach(function (btn) {
      if (btn.dataset.wired) return;
      btn.dataset.wired = "1";
      btn.addEventListener("click", function () {
        var root = btn.closest(".mb2ag");
        var name = "MyoBuddy";
        var qty = 1;
        if (btn.dataset.qty) {
          var out = root.querySelector(btn.dataset.qty);
          if (out) qty = parseInt(out.textContent, 10);
        }
        if (btn.dataset.name) {
          var t = root.querySelector(btn.dataset.name);
          if (t) name = t.textContent;
        } else if (btn.dataset.nameStr) {
          name = btn.dataset.nameStr;
        }
        showToast(name + " added to cart (" + qty + ")");
      });
    });

    /* proven-results tabs */
    document.querySelectorAll(".mb2ag .tabs").forEach(function (tabs) {
      if (tabs.dataset.wired) return;
      tabs.dataset.wired = "1";
      var root = tabs.closest(".mb2ag");
      var tabImg = root.querySelector("[data-mb2ag-tab-img]");
      var tabCap = root.querySelector("[data-mb2ag-tab-cap]");
      tabs.querySelectorAll(".tab").forEach(function (t) {
        t.addEventListener("click", function () {
          tabs.querySelectorAll(".tab").forEach(function (x) {
            x.classList.remove("on");
          });
          t.classList.add("on");
          if (tabCap && t.dataset.cap) tabCap.textContent = t.dataset.cap;
          if (tabImg && t.dataset.img) {
            tabImg.style.opacity = 0;
            setTimeout(function () {
              tabImg.src = t.dataset.img;
              tabImg.onload = function () {
                tabImg.style.opacity = 1;
              };
            }, 200);
          }
        });
      });
    });

    /* PDP gallery — vertical thumbs switch the main viewer */
    document.querySelectorAll("[data-mb2ag-gallery]").forEach(function (gallery) {
      if (gallery.dataset.wired) return;
      gallery.dataset.wired = "1";
      var thumbs = gallery.querySelectorAll("[data-mb2ag-thumb]");
      var slides = gallery.querySelectorAll("[data-mb2ag-slide]");
      var zoomBtn = gallery.querySelector("[data-mb2ag-zoom]");

      function currentSlide() {
        var active = null;
        slides.forEach(function (s) {
          if (!s.hasAttribute("hidden")) active = s;
        });
        return active;
      }

      function syncZoom(slide) {
        if (!zoomBtn) return;
        var type = slide && slide.getAttribute("data-media-type");
        var hide = !slide || type === "video" || type === "external_video" || type === "stat" || type === "model";
        if (hide) zoomBtn.setAttribute("hidden", "");
        else zoomBtn.removeAttribute("hidden");
      }

      function show(id) {
        if (id == null || id === "") return false;
        var allSlides = gallery.querySelectorAll("[data-mb2ag-slide]");
        var allThumbs = gallery.querySelectorAll("[data-mb2ag-thumb]");
        var match = null;
        allSlides.forEach(function (s) {
          if (String(s.getAttribute("data-mb2ag-slide")) === String(id)) match = s;
        });
        if (!match) return false;
        allSlides.forEach(function (s) {
          var on = s === match;
          if (on) {
            s.removeAttribute("hidden");
            s.classList.add("is-active");
          } else {
            s.setAttribute("hidden", "");
            s.classList.remove("is-active", "is-playing");
            var v = s.querySelector("video");
            if (v) v.pause();
          }
        });
        allThumbs.forEach(function (t) {
          var on = String(t.getAttribute("data-mb2ag-thumb")) === String(id);
          t.classList.toggle("is-active", on);
          t.setAttribute("aria-selected", on ? "true" : "false");
        });
        syncZoom(match);
        return true;
      }

      gallery.__mb2agShow = show;

      thumbs.forEach(function (thumb) {
        thumb.addEventListener("click", function () {
          show(thumb.getAttribute("data-mb2ag-thumb"));
        });
      });

      syncZoom(currentSlide());

      if (zoomBtn) {
        var overlay = document.querySelector("[data-mb2ag-zoom-overlay]");
        if (!overlay) {
          overlay = document.createElement("div");
          overlay.className = "mb2ag";
          overlay.innerHTML =
            '<div class="g-zoom-overlay" data-mb2ag-zoom-overlay hidden role="dialog" aria-modal="true" aria-label="Zoomed image">' +
            '<button type="button" class="g-zoom-close" data-mb2ag-zoom-close aria-label="Close">&times;</button>' +
            '<img data-mb2ag-zoom-img alt="">' +
            "</div>";
          document.body.appendChild(overlay);
        }
        var panel = overlay.querySelector("[data-mb2ag-zoom-overlay]") || overlay;
        var zoomImg = overlay.querySelector("[data-mb2ag-zoom-img]");
        function closeZoom() {
          panel.setAttribute("hidden", "");
          document.body.style.overflow = "";
        }
        zoomBtn.addEventListener("click", function (e) {
          e.preventDefault();
          var slide = currentSlide();
          if (!slide || !zoomImg) return;
          var img = slide.querySelector("img:not(.g-poster)") || slide.querySelector("img");
          if (!img || !img.src) return;
          zoomImg.src = img.currentSrc || img.src;
          zoomImg.alt = img.alt || "";
          panel.removeAttribute("hidden");
          document.body.style.overflow = "hidden";
        });
        overlay.querySelectorAll("[data-mb2ag-zoom-close]").forEach(function (btn) {
          btn.addEventListener("click", closeZoom);
        });
        panel.addEventListener("click", function (e) {
          if (e.target === panel) closeZoom();
        });
        document.addEventListener("keydown", function (e) {
          if (e.key === "Escape" && !panel.hasAttribute("hidden")) closeZoom();
        });
      }
    });
    document.querySelectorAll("[data-mb2ag-carousel]").forEach(function (carousel) {
      if (carousel.dataset.wired) return;
      carousel.dataset.wired = "1";
      var wrap = carousel.parentElement;
      var dotsWrap = wrap.querySelector("[data-mb2ag-dots]");
      if (!dotsWrap) return;
      var slides = carousel.querySelectorAll(".g-slide");
      dotsWrap.innerHTML = "";
      slides.forEach(function (_, i) {
        var d = document.createElement("i");
        if (i === 0) d.className = "on";
        dotsWrap.appendChild(d);
      });
      var dots = dotsWrap.querySelectorAll("i");
      carousel.addEventListener(
        "scroll",
        function () {
          var i = Math.round(carousel.scrollLeft / Math.max(carousel.clientWidth, 1));
          dots.forEach(function (d, j) {
            d.classList.toggle("on", j === i);
          });
          slides.forEach(function (slide, j) {
            if (j === i) return;
            var v = slide.querySelector("video");
            if (v && !v.paused) {
              v.pause();
              slide.classList.remove("is-playing");
            }
          });
        },
        { passive: true }
      );
    });

    /* related products carousel dots (when > 3 products) */
    document.querySelectorAll("[data-mb2ag-related-carousel]").forEach(function (carousel) {
      if (carousel.dataset.wired) return;
      carousel.dataset.wired = "1";
      var section = carousel.closest("section") || carousel.parentElement;
      var dotsWrap = section && section.querySelector("[data-mb2ag-related-dots]");
      if (!dotsWrap) return;
      var cards = carousel.querySelectorAll(".rel-card");
      if (cards.length < 2) return;
      dotsWrap.innerHTML = "";
      cards.forEach(function (_, i) {
        var d = document.createElement("i");
        if (i === 0) d.className = "on";
        dotsWrap.appendChild(d);
      });
      var dots = dotsWrap.querySelectorAll("i");
      function syncDots() {
        var cardW = cards[0].getBoundingClientRect().width + 22;
        var i = Math.round(carousel.scrollLeft / Math.max(cardW, 1));
        i = Math.max(0, Math.min(cards.length - 1, i));
        dots.forEach(function (d, j) {
          d.classList.toggle("on", j === i);
        });
      }
      carousel.addEventListener("scroll", syncDots, { passive: true });
      window.addEventListener("resize", syncDots, { passive: true });
    });

    /* write a review → open Judge.me review form */
    function findJudgeMeWriteButton() {
      return (
        document.querySelector('[data-testid="write-review-button"]') ||
        document.querySelector(".jm-action-buttons__button.jm-button--primary") ||
        document.querySelector(".jm-action-buttons__button") ||
        document.querySelector("a.jdgm-write-rev-link") ||
        document.querySelector(".jdgm-write-rev-link") ||
        document.querySelector(".jdgm-widget-actions a") ||
        document.querySelector(".jdgm-btn.jdgm-btn--solid")
      );
    }

    function openJudgeMeReviewForm() {
      var jmBtn = findJudgeMeWriteButton();
      if (!jmBtn) return false;
      try {
        jmBtn.click();
      } catch (err) {
        return false;
      }
      return true;
    }

    function wireWriteReviewButtons() {
      document.querySelectorAll("[data-mb2ag-write-review]").forEach(function (btn) {
        if (btn.dataset.wired) return;
        btn.dataset.wired = "1";
        btn.addEventListener("click", function (e) {
          e.preventDefault();
          if (openJudgeMeReviewForm()) return;

          var tries = 0;
          var timer = setInterval(function () {
            tries += 1;
            if (openJudgeMeReviewForm() || tries >= 40) clearInterval(timer);
          }, 125);
        });
      });
    }

    wireWriteReviewButtons();

    if (typeof MutationObserver !== "undefined") {
      var jmWatch = new MutationObserver(function () {
        if (findJudgeMeWriteButton()) {
          document.documentElement.classList.add("mb2ag-jm-ready");
          jmWatch.disconnect();
        }
      });
      jmWatch.observe(document.documentElement, { childList: true, subtree: true });
    }

    /* reviews pager */
    document.querySelectorAll("[data-mb2ag-reviews]").forEach(function (section) {
      if (section.dataset.wired) return;
      section.dataset.wired = "1";
      var pager = section.querySelector("[data-mb2ag-review-pager]");
      var reviews = section.querySelectorAll("[data-mb2ag-review]");
      if (!pager || !reviews.length) return;

      function showPage(page) {
        var pageNum = String(page);
        reviews.forEach(function (review) {
          var match = review.getAttribute("data-page") === pageNum;
          if (match) {
            review.hidden = false;
            review.classList.add("in");
          } else {
            review.hidden = true;
          }
        });
        pager.querySelectorAll("button").forEach(function (btn) {
          btn.classList.toggle("on", btn.getAttribute("data-page") === pageNum);
        });
        var head = section.querySelector(".rev-head");
        if (head && head.scrollIntoView) {
          head.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }

      pager.addEventListener("click", function (e) {
        var btn = e.target.closest("button[data-page]");
        if (!btn) return;
        e.preventDefault();
        showPage(btn.getAttribute("data-page"));
      });
    });

    /* reveal on scroll */
    var rivs = document.querySelectorAll(".mb2ag .rv");
    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              e.target.classList.add("in");
              io.unobserve(e.target);
            }
          });
        },
        { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
      );
      rivs.forEach(function (el) {
        io.observe(el);
      });
    } else {
      rivs.forEach(function (el) {
        el.classList.add("in");
      });
    }

    function showToast(msg) {
      var toast = document.getElementById("mb2ag-toast");
      if (!toast) {
        toast = document.createElement("div");
        toast.className = "toast";
        toast.id = "mb2ag-toast";
        toast.innerHTML = '<span class="tick">✓</span><span class="mb2ag-toast-msg"></span>';
        var wrap = document.createElement("div");
        wrap.className = "mb2ag";
        wrap.appendChild(toast);
        document.body.appendChild(wrap);
      }
      var tm = toast.querySelector(".mb2ag-toast-msg");
      if (tm) tm.textContent = msg;
      toast.classList.add("show");
      clearTimeout(window.__mb2agToastTimer);
      window.__mb2agToastTimer = setTimeout(function () {
        toast.classList.remove("show");
      }, 2600);
    }
  });
})();
